import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Card = ({ key, items }) => {
 
  const {
    AuthReducer: { auth, errors },
  } = useSelector((state) => state);

  const router = useNavigate();

  return (
    <>
      <div className="col-md-6 mb-5" key={key}>
        <div className="card-nine bg-gray">
          <div className="card-nine-img bg-accent-light">
            <Image
              src={`https://msmesupplier.s3.ap-south-1.amazonaws.com/${items?.image}`} 
              // layout="fill"
              objectFit="cover"
              alt="project-reports"
              className="img-fluid"
            />
          </div>
          <div className="card-nine-body">
            <div className="card-nine-body-top">
              <h5
                className="dot-1 mb-2 fw-bold cursor text-primary"
                title={items?.name}
                style={{ width: 170 }}
                onClick={() =>
                  router(
                    `/supplier-products/${items?.id?.toString()}`
                  )
                }
              >
                {items?.name}
              </h5>
              <span className="d-block">
                <span className="text-secondary">Supplier Name</span>:{" "}
                {items?.supplier?.name}
              </span>
            </div>
            <div className="card-nine-body-bottom">
              <h5>₹ {items?.price} /-</h5>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
